module.exports = __webpack_public_path__ + "static/media/ic_searchtype_cave.ecb0042d.svg";